export const themes = {
  classic: {
    name: 'Classic',
    description: 'Traditionelt og professionelt design',
    colors: {
      primary: 'bg-blue-600 hover:bg-blue-700',
      primaryText: 'text-blue-600',
      primaryBg: 'bg-blue-50',
      primaryBorder: 'border-blue-500',
      secondary: 'bg-gray-100 hover:bg-gray-200',
      success: 'bg-green-600 hover:bg-green-700',
      successText: 'text-green-600',
      successBg: 'bg-green-50',
      card: 'bg-white',
      cardBorder: 'border-gray-200',
      header: 'bg-white',
    },
    shadows: {
      card: 'shadow-sm',
      button: '',
      header: 'shadow-sm',
    },
    spacing: {
      card: 'p-4 sm:p-6',
      compact: 'p-3 sm:p-4',
    },
    rounded: {
      card: 'rounded-xl',
      button: 'rounded-lg',
    },
    transitions: {
      default: 'transition-colors',
    },
  },
  smart: {
    name: 'Smart',
    description: 'Moderne og elegant design med optimeret mobilvisning',
    colors: {
      primary: 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800',
      primaryText: 'text-blue-700',
      primaryBg: 'bg-gradient-to-br from-blue-50 to-blue-100',
      primaryBorder: 'border-blue-600',
      secondary: 'bg-gradient-to-br from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-150',
      success:
        'bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700',
      successText: 'text-emerald-700',
      successBg: 'bg-gradient-to-br from-emerald-50 to-green-50',
      card: 'bg-white',
      cardBorder: 'border-gray-100',
      header: 'bg-white/95 backdrop-blur-sm',
    },
    shadows: {
      card: 'shadow-md hover:shadow-lg',
      button: 'shadow-sm hover:shadow-md',
      header: 'shadow-lg',
    },
    spacing: {
      card: 'p-5 sm:p-7',
      compact: 'p-4 sm:p-5',
    },
    rounded: {
      card: 'rounded-2xl',
      button: 'rounded-xl',
    },
    transitions: {
      default: 'transition-all duration-200',
    },
  },
};

export type ThemeConfig = typeof themes.classic;
